module.exports = __webpack_public_path__ + "graphics/checkout-gift-icon.ckh.47e22f0b3d5ceaf82f7198149c35f798.svg";